import React from "react";
import { Input, Label } from "reactstrap";
import { AsyncPaginatedSelect } from "components/common/AsyncPaginatedSelect";
import {
  getMaterialOptions,
  getProductCategoryOptions,
  getProductTypeOptions,
  getUomOptions,
} from "features/Meta/services/MetaService";
import type { SelectOption } from "types/api.types";

export type ProductListFiltersProps = {
  isActiveFilter: "" | "true" | "false";
  onIsActiveChange: (value: "" | "true" | "false") => void;
  categoryId: number | null;
  onCategoryIdChange: (value: number | null) => void;
  productTypeId: number | null;
  onProductTypeIdChange: (value: number | null) => void;
  materialId: number | null;
  onMaterialIdChange: (value: number | null) => void;
  uomId: number | null;
  onUomIdChange: (value: number | null) => void;
  brand: string;
  onBrandChange: (value: string) => void;
  manufacturer: string;
  onManufacturerChange: (value: string) => void;
};

const FIELD_IDS = {
  status: "product-list-filter-active",
  brand: "product-list-filter-brand",
  manufacturer: "product-list-filter-manufacturer",
} as const;

export default function ProductListFilters({
  isActiveFilter,
  onIsActiveChange,
  categoryId,
  onCategoryIdChange,
  productTypeId,
  onProductTypeIdChange,
  materialId,
  onMaterialIdChange,
  uomId,
  onUomIdChange,
  brand,
  onBrandChange,
  manufacturer,
  onManufacturerChange,
}: ProductListFiltersProps) {
  return (
    <div className="product-list-filters w-100 min-w-0">
      <div className="d-flex flex-column gap-3">
        <div className="d-flex flex-column gap-1">
          <Label
            className="form-label text-muted small mb-0"
            htmlFor={FIELD_IDS.status}
          >
            Status
          </Label>
          <Input
            id={FIELD_IDS.status}
            type="select"
            className="form-select"
            value={isActiveFilter}
            onChange={(e) =>
              onIsActiveChange(e.target.value as "" | "true" | "false")
            }
          >
            <option value="">All</option>
            <option value="true">Active</option>
            <option value="false">Inactive</option>
          </Input>
        </div>

        <div className="d-flex flex-column gap-1">
          <Label className="form-label text-muted small mb-0">Category</Label>
          <AsyncPaginatedSelect
            fetchOptions={getProductCategoryOptions}
            placeholder="Search category…"
            value={categoryId}
            onChange={(opt) =>
              onCategoryIdChange(
                opt && !Array.isArray(opt)
                  ? Number((opt as SelectOption).value)
                  : null,
              )
            }
          />
        </div>

        <div className="d-flex flex-column gap-1">
          <Label className="form-label text-muted small mb-0">Product type</Label>
          <AsyncPaginatedSelect
            fetchOptions={getProductTypeOptions}
            placeholder="Search type…"
            value={productTypeId}
            onChange={(opt) =>
              onProductTypeIdChange(
                opt && !Array.isArray(opt)
                  ? Number((opt as SelectOption).value)
                  : null,
              )
            }
          />
        </div>

        <div className="d-flex flex-column gap-1">
          <Label className="form-label text-muted small mb-0">
            Catalog material
          </Label>
          <AsyncPaginatedSelect
            fetchOptions={getMaterialOptions}
            placeholder="Search material…"
            value={materialId}
            onChange={(opt) =>
              onMaterialIdChange(
                opt && !Array.isArray(opt)
                  ? Number((opt as SelectOption).value)
                  : null,
              )
            }
          />
        </div>

        <div className="d-flex flex-column gap-1">
          <Label className="form-label text-muted small mb-0">
            Unit of measure
          </Label>
          <AsyncPaginatedSelect
            fetchOptions={getUomOptions}
            placeholder="Search UOM…"
            value={uomId}
            onChange={(opt) =>
              onUomIdChange(
                opt && !Array.isArray(opt)
                  ? Number((opt as SelectOption).value)
                  : null,
              )
            }
          />
        </div>

        <div className="d-flex flex-column gap-1">
          <Label
            className="form-label text-muted small mb-0"
            htmlFor={FIELD_IDS.brand}
          >
            Brand contains
          </Label>
          <Input
            id={FIELD_IDS.brand}
            type="text"
            className="form-control"
            placeholder="Partial match"
            value={brand}
            onChange={(e) => onBrandChange(e.target.value)}
          />
        </div>

        <div className="d-flex flex-column gap-1">
          <Label
            className="form-label text-muted small mb-0"
            htmlFor={FIELD_IDS.manufacturer}
          >
            Manufacturer contains
          </Label>
          <Input
            id={FIELD_IDS.manufacturer}
            type="text"
            className="form-control"
            placeholder="Partial match"
            value={manufacturer}
            onChange={(e) => onManufacturerChange(e.target.value)}
          />
        </div>
      </div>
    </div>
  );
}
